var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerified24Dp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "verified_black_24dp") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: 217,
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0309\\u66F4\\u65B0-space-featured\\u9875\\u9762\\u5907\\u4EFD-3",
    transform: "translate(-670.000000, -776.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-7",
    transform: "translate(348.000000, 682.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-3\\u5907\\u4EFD",
    transform: "translate(252.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-4",
    transform: "translate(60.000000, 88.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "verified_black_24dp",
    transform: "translate(10.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u5F62\\u72B6",
    fill: "#7269EF",
    fillRule: "nonzero",
    points: "23 12 20.56 9.21 20.9 5.52 17.29 4.7 15.4 1.5 12 2.96 8.6 1.5 6.71 4.69 3.1 5.5 3.44 9.2 1 12 3.44 14.79 3.1 18.49 6.71 19.31 8.6 22.5 12 21.03 15.4 22.49 17.29 19.3 20.9 18.48 20.56 14.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "10.09 16.72 6.29 12.91 7.77 11.43 10.09 13.76 15.94 7.89 17.42 9.37"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified24Dp);
export default __webpack_public_path__ + "static/media/verified_24dp.12f6680fcefdf11e1bbdb58dfb55e536.svg";
export { ForwardRef as ReactComponent };